import styled from 'styled-components'

const Container = styled.div`
`
const Wrapper = styled.div`
    box-shadow: 0 0 12px 0 rgb(0 0 0 / 8%);
    background-color: #ffffff;
    min-height: 249px;
    position: relative;
    -webkit-flex: 1;
    -ms-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;

`
const ContentHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: solid 1px #97979729;
        padding: 0 20px;
        height: 80px;
    h3 {
        text-transform: uppercase;
        font-family: "latobold";
        font-size: 16px;
    }
`
const SellerInfo = styled.div`
    padding: 0px 15px 0px 23px;
`
const Reviews = styled.div``

const PanelWrapper = styled.div`
    background-color: #f9f9f9;
    padding: 15px;
    margin: 10px 0;
         p {
            margin:0;
            span {
                color: orange;
            }
        }
        > span {
                margin-top: 15px;
    font-size: 14px;
    display: flex;
`



export { Container, ContentHeader, SellerInfo, Reviews, Wrapper, PanelWrapper }